export const CARDS_PER_LEVEL = 16;
